import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Str from "shared/components/Str";

import "./Package.scss";

const Package = ({
	productid,
	subPeriod,
	initialUnitPrice,
	onClick,
	topPrice,
	mostPopular,
	formattedInitialUnitPrice,
}) => (
	<div className="incognitopackages-package">
		{mostPopular &&
			<div className="incognitopackages-package-popular">
				<Str className="incognitopackages-package-popular-ribbon" />
				<Str className="incognitopackages-package-popular-text">Best Value</Str>
			</div>
		}

		<div className="incognitopackages-package-period">
			<span className="incognitopackages-package-period-count">{subPeriod}</span>
			{" "}
			{subPeriod === 1 && <Str className="incognitopackages-package-period-unit">month</Str>}
			{subPeriod !== 1 && <Str className="incognitopackages-package-period-unit">months</Str>}
		</div>

		<div className="incognitopackages-package-price">
			<span dangerouslySetInnerHTML={{ __html: formattedInitialUnitPrice }} />
			{" "}
			/
			{" "}
			<Str>month</Str>

			{initialUnitPrice !== topPrice &&
				<div className="incognitopackages-package-price-savings">
					Save {Math.round(100 - 100 * (initialUnitPrice / topPrice))}%
				</div>
			}
		</div>

		<div className="incognitopackages-package-cta">
			<button
				className={classnames("incognitopackages-package-cta-button big flatbutton", {
					"blue": mostPopular,
					"clear light-bg": !mostPopular,
				})}
				onClick={() => onClick(productid)}
			>
				<Str>Choose</Str>
			</button>
		</div>
	</div>
);

Package.propTypes = {
	mostPopular: PropTypes.bool.isRequired,
	productid: PropTypes.string.isRequired,
	subPeriod: PropTypes.number.isRequired,
	initialUnitPrice: PropTypes.number.isRequired,
	topPrice: PropTypes.number.isRequired,
	onClick: PropTypes.func.isRequired,
	formattedInitialUnitPrice: PropTypes.string,
};

export default Package;



// WEBPACK FOOTER //
// ./src/apps/incognito_packages/components/Package.jsx